const translations = {
  en: {
    // Nav
    dashboard: 'Dashboard', notifications: 'Notifications', messages: 'Messages',
    members: 'Members', visitors: 'Visitors', families: 'Families', volunteers: 'Volunteers',
    groups: 'Groups & Ministries', ministries: 'Ministries/Depts', attendance: 'Attendance',
    eventCheckIn: 'Event Check-In', servicePlanner: 'Service Planner', liveStream: 'Live Stream',
    mediaSermons: 'Media & Sermons', bible: 'Bible', events: 'Events',
    tithesOfferings: 'Tithes & Offerings', onlineGiving: 'Online Giving',
    donorAnalytics: 'Donor Analytics', pledges: 'Pledges', engagementScores: 'Engagement Scores',
    followUps: 'Follow-ups & Tasks', appointments: 'Appointments', consultations: 'Consultations',
    prayerRequests: 'Prayer Requests', testimonies: 'Testimonies', announcements: 'Announcements',
    userManagement: 'User Management', assets: 'Assets/Inventory', campaigns: 'Campaigns',
    documents: 'Documents', reports: 'Reports', reportBuilder: 'Report Builder',
    automation: 'Automation', settings: 'Settings', aiAssistant: 'AI Assistant',
    aiAnalytics: 'AI Analytics', sermonTools: 'Sermon & Study Tools',
    // Sections
    main: 'Main', aiTools: 'AI Tools', people: 'People', worship: 'Worship',
    giving: 'Giving', care: 'Care', admin: 'Admin',
    // Common
    welcome: 'Welcome', signIn: 'Sign In', signOut: 'Logout', createAccount: 'Create Account',
    save: 'Save', cancel: 'Cancel', delete: 'Delete', edit: 'Edit', add: 'Add',
    search: 'Search', loading: 'Loading...', noData: 'No data available',
    profile: 'Profile', submit: 'Submit', close: 'Close', viewAll: 'View All',
    email: 'Email', password: 'Password', phone: 'Phone', name: 'Name',
    firstName: 'First Name', lastName: 'Last Name', status: 'Status',
    active: 'Active', inactive: 'Inactive', pending: 'Pending', completed: 'Completed',
    date: 'Date', time: 'Time', type: 'Type', amount: 'Amount', total: 'Total',
    actions: 'Actions', details: 'Details', description: 'Description', notes: 'Notes',
    // Dashboard
    totalMembers: 'Total Members', todayAttendance: "Today's Attendance",
    thisMonthGiving: "This Month's Giving", activeGroups: 'Active Groups',
    dailyVerse: 'Daily Verse', quickLinks: 'Quick Links',
    upcomingEvents: 'Upcoming Events', recentAnnouncements: 'Recent Announcements',
    whatsHappening: "Here's what's happening at your church today",
    newMember: 'New Member', recordAttendance: 'Record Attendance', announcement: 'Announcement',
    readBible: 'Read Bible', give: 'Give', prayer: 'Prayer',
    // Members
    addMember: 'Add Member', searchMembers: 'Search members...',
    memberAdded: 'Member added', memberUpdated: 'Member updated', memberDeleted: 'Member deleted',
    // Attendance
    recordAttendanceTitle: 'Record Attendance', presentToday: 'Present Today',
    totalMembersLabel: 'Total Members', todayRecords: "Today's Records",
    noAttendanceToday: 'No attendance recorded today', saveAttendance: 'Save Attendance',
    serviceType: 'Service Type', present: 'Present', absent: 'Absent',
    // Giving
    recordGiving: 'Record Giving', totalGiving: 'Total Giving', recentRecords: 'Recent Records',
    noGivingRecords: 'No giving records yet', givingRecorded: 'Giving recorded',
    tithe: 'Tithe', offering: 'Offering', donation: 'Donation', pledge: 'Pledge',
    cash: 'Cash', card: 'Card', bankTransfer: 'Bank Transfer', online: 'Online',
    paymentMethod: 'Payment Method', donationType: 'Donation Type',
    // Events
    noEvents: 'No events scheduled', rsvp: 'RSVP', registeredForEvent: 'Registered for event',
    // Bible
    dailyVerseTitle: 'Daily Verse', searchBible: 'Search Bible',
    bookmarks: 'Bookmarks', noBookmarks: 'No bookmarks yet',
    bookmarkSaved: 'Bookmark saved',
    // Prayer
    newPrayerRequest: 'New Prayer Request', submitAnonymously: 'Submit Anonymously',
    submitRequest: 'Submit Request', noPrayerRequests: 'No prayer requests',
    // Announcements
    noAnnouncements: 'No announcements', pinned: 'Pinned',
    // Profile
    changePassword: 'Change Password', currentPassword: 'Current Password',
    newPassword: 'New Password', profileUpdated: 'Profile updated',
    passwordChanged: 'Password changed',
    // Settings
    churchProfile: 'Church Profile', apiKeys: 'API Keys',
    saveChurchProfile: 'Save Church Profile', saveApiKeys: 'Save All API Keys',
    // Check-In
    qrCode: 'QR Code', checkIn: 'Check In', checkInLog: 'Check-In Log',
    totalCheckIns: 'Total Check-Ins', today: 'Today', generateQR: 'Generate QR Code',
    checkedIn: 'Checked in successfully', alreadyCheckedIn: 'Already checked in',
    downloadQR: 'Download QR Code', selectEvent: 'Select event...',
    // Engagement
    engagementTitle: 'Member Engagement', avgScore: 'Avg Score',
    engaged: 'Engaged', atRisk: 'At Risk', disengaged: 'Disengaged',
    // Donor Analytics
    avgGift: 'Avg Gift', totalGifts: 'Total Gifts', activeDonors: 'Active Donors',
    newDonors: 'New Donors (30d)', lapsedDonors: 'Lapsed Donors',
    monthlyTrends: 'Monthly Trends', breakdown: 'Breakdown', topDonors: 'Top Donors',
    // AI Analytics
    aiChurchAnalytics: 'AI Church Analytics', generateAISummary: 'Generate AI Summary',
    generating: 'Generating...', weekDetails: 'Week Details', pastSummaries: 'Past Summaries',
    aiSummary: 'AI Summary', noSummaryYet: 'No AI summary yet', generateNow: 'Generate Now',
    // Automation
    automationWorkflows: 'Automation Workflows', executeAll: 'Execute All Automations',
    executeNow: 'Execute Now', running: 'Running...', executionHistory: 'Execution History',
    automationSchedule: 'Automation Schedule',
    // Online Giving
    makeADonation: 'Make a Donation', selectAmount: 'Select Amount',
    customAmount: 'Custom amount', recurringDonation: 'Make this a recurring donation',
    donorInfo: 'Donor Information', fullName: 'Full Name', emailAddress: 'Email Address',
    donate: 'Donate', whyGive: 'Why Give?',
    // Reports
    generateReport: 'Generate Report', exportCSV: 'Export CSV',
    noReportGenerated: 'No Report Generated', configureReport: 'Configure Report',
    reportType: 'Report Type', dateRange: 'Date Range', fromDate: 'From Date', toDate: 'To Date',
    // Language
    language: 'Language',
  },
  es: {
    // Nav
    dashboard: 'Panel', notifications: 'Notificaciones', messages: 'Mensajes',
    members: 'Miembros', visitors: 'Visitantes', families: 'Familias', volunteers: 'Voluntarios',
    groups: 'Grupos y Ministerios', ministries: 'Ministerios/Dptos', attendance: 'Asistencia',
    eventCheckIn: 'Registro de Eventos', servicePlanner: 'Planificador', liveStream: 'En Vivo',
    mediaSermons: 'Medios y Sermones', bible: 'Biblia', events: 'Eventos',
    tithesOfferings: 'Diezmos y Ofrendas', onlineGiving: 'Dar en Linea',
    donorAnalytics: 'Analisis de Donantes', pledges: 'Promesas',
    engagementScores: 'Puntuacion de Participacion', followUps: 'Seguimientos',
    appointments: 'Citas', consultations: 'Consultas', prayerRequests: 'Peticiones de Oracion',
    testimonies: 'Testimonios', announcements: 'Anuncios', userManagement: 'Gestion de Usuarios',
    assets: 'Activos/Inventario', campaigns: 'Campanas', documents: 'Documentos',
    reports: 'Reportes', reportBuilder: 'Constructor de Reportes', automation: 'Automatizacion',
    settings: 'Configuracion', aiAssistant: 'Asistente IA', aiAnalytics: 'Analisis IA',
    sermonTools: 'Herramientas de Sermon',
    // Sections
    main: 'Principal', aiTools: 'Herramientas IA', people: 'Personas', worship: 'Adoracion',
    giving: 'Ofrendas', care: 'Cuidado', admin: 'Admin',
    // Common
    welcome: 'Bienvenido', signIn: 'Iniciar Sesion', signOut: 'Cerrar Sesion',
    createAccount: 'Crear Cuenta', save: 'Guardar', cancel: 'Cancelar', delete: 'Eliminar',
    edit: 'Editar', add: 'Agregar', search: 'Buscar', loading: 'Cargando...',
    noData: 'Sin datos', profile: 'Perfil', submit: 'Enviar', close: 'Cerrar',
    viewAll: 'Ver Todo', email: 'Correo', password: 'Contrasena', phone: 'Telefono',
    name: 'Nombre', firstName: 'Nombre', lastName: 'Apellido', status: 'Estado',
    active: 'Activo', inactive: 'Inactivo', pending: 'Pendiente', completed: 'Completado',
    date: 'Fecha', time: 'Hora', type: 'Tipo', amount: 'Monto', total: 'Total',
    actions: 'Acciones', details: 'Detalles', description: 'Descripcion', notes: 'Notas',
    // Dashboard
    totalMembers: 'Total de Miembros', todayAttendance: 'Asistencia de Hoy',
    thisMonthGiving: 'Ofrendas del Mes', activeGroups: 'Grupos Activos',
    dailyVerse: 'Versiculo del Dia', quickLinks: 'Accesos Rapidos',
    upcomingEvents: 'Proximos Eventos', recentAnnouncements: 'Anuncios Recientes',
    whatsHappening: 'Esto es lo que pasa en tu iglesia hoy',
    newMember: 'Nuevo Miembro', recordAttendance: 'Registrar Asistencia', announcement: 'Anuncio',
    readBible: 'Leer Biblia', give: 'Dar', prayer: 'Oracion',
    // Members
    addMember: 'Agregar Miembro', searchMembers: 'Buscar miembros...',
    memberAdded: 'Miembro agregado', memberUpdated: 'Miembro actualizado',
    memberDeleted: 'Miembro eliminado',
    // Attendance
    recordAttendanceTitle: 'Registrar Asistencia', presentToday: 'Presentes Hoy',
    totalMembersLabel: 'Total de Miembros', todayRecords: 'Registros de Hoy',
    noAttendanceToday: 'No se ha registrado asistencia hoy', saveAttendance: 'Guardar Asistencia',
    serviceType: 'Tipo de Servicio', present: 'Presente', absent: 'Ausente',
    // Giving
    recordGiving: 'Registrar Ofrenda', totalGiving: 'Total de Ofrendas',
    recentRecords: 'Registros Recientes', noGivingRecords: 'Aun no hay registros de ofrendas',
    givingRecorded: 'Ofrenda registrada',
    tithe: 'Diezmo', offering: 'Ofrenda', donation: 'Donacion', pledge: 'Promesa',
    cash: 'Efectivo', card: 'Tarjeta', bankTransfer: 'Transferencia', online: 'En Linea',
    paymentMethod: 'Metodo de Pago', donationType: 'Tipo de Donacion',
    // Events
    noEvents: 'No hay eventos', rsvp: 'Confirmar', registeredForEvent: 'Registrado para el evento',
    // Bible
    dailyVerseTitle: 'Versiculo del Dia', searchBible: 'Buscar en la Biblia',
    bookmarks: 'Marcadores', noBookmarks: 'Aun no hay marcadores',
    bookmarkSaved: 'Marcador guardado',
    // Prayer
    newPrayerRequest: 'Nueva Peticion', submitAnonymously: 'Enviar Anonimamente',
    submitRequest: 'Enviar Peticion', noPrayerRequests: 'No hay peticiones de oracion',
    // Announcements
    noAnnouncements: 'No hay anuncios', pinned: 'Fijado',
    // Profile
    changePassword: 'Cambiar Contrasena', currentPassword: 'Contrasena Actual',
    newPassword: 'Nueva Contrasena', profileUpdated: 'Perfil actualizado',
    passwordChanged: 'Contrasena cambiada',
    // Settings
    churchProfile: 'Perfil de la Iglesia', apiKeys: 'Claves API',
    saveChurchProfile: 'Guardar Perfil de la Iglesia', saveApiKeys: 'Guardar Todas las Claves API',
    // Check-In
    qrCode: 'Codigo QR', checkIn: 'Registrarse', checkInLog: 'Registro de Entradas',
    totalCheckIns: 'Total de Registros', today: 'Hoy', generateQR: 'Generar Codigo QR',
    checkedIn: 'Registrado exitosamente', alreadyCheckedIn: 'Ya registrado',
    downloadQR: 'Descargar Codigo QR', selectEvent: 'Seleccionar evento...',
    // Engagement
    engagementTitle: 'Participacion de Miembros', avgScore: 'Puntaje Promedio',
    engaged: 'Comprometido', atRisk: 'En Riesgo', disengaged: 'Desconectado',
    // Donor Analytics
    avgGift: 'Promedio', totalGifts: 'Total de Dones', activeDonors: 'Donantes Activos',
    newDonors: 'Nuevos Donantes', lapsedDonors: 'Donantes Inactivos',
    monthlyTrends: 'Tendencias Mensuales', breakdown: 'Desglose', topDonors: 'Top Donantes',
    // AI Analytics
    aiChurchAnalytics: 'Analisis IA de la Iglesia', generateAISummary: 'Generar Resumen IA',
    generating: 'Generando...', weekDetails: 'Detalles de la Semana',
    pastSummaries: 'Resumenes Anteriores', aiSummary: 'Resumen IA',
    noSummaryYet: 'Aun no hay resumen IA', generateNow: 'Generar Ahora',
    // Automation
    automationWorkflows: 'Flujos de Automatizacion', executeAll: 'Ejecutar Todas las Automatizaciones',
    executeNow: 'Ejecutar Ahora', running: 'Ejecutando...',
    executionHistory: 'Historial de Ejecucion', automationSchedule: 'Programacion de Automatizacion',
    // Online Giving
    makeADonation: 'Hacer una Donacion', selectAmount: 'Seleccionar Monto',
    customAmount: 'Monto personalizado', recurringDonation: 'Hacer de esto una donacion recurrente',
    donorInfo: 'Informacion del Donante', fullName: 'Nombre Completo', emailAddress: 'Correo Electronico',
    donate: 'Donar', whyGive: 'Por que Dar?',
    // Reports
    generateReport: 'Generar Reporte', exportCSV: 'Exportar CSV',
    noReportGenerated: 'No se ha generado ningun reporte', configureReport: 'Configurar Reporte',
    reportType: 'Tipo de Reporte', dateRange: 'Rango de Fechas', fromDate: 'Desde', toDate: 'Hasta',
    // Language
    language: 'Idioma',
  },
  fr: {
    // Nav
    dashboard: 'Tableau de Bord', notifications: 'Notifications', messages: 'Messages',
    members: 'Membres', visitors: 'Visiteurs', families: 'Familles', volunteers: 'Benevoles',
    groups: 'Groupes et Ministeres', ministries: 'Ministeres/Depts', attendance: 'Presence',
    eventCheckIn: 'Enregistrement', servicePlanner: 'Planificateur', liveStream: 'En Direct',
    mediaSermons: 'Medias et Sermons', bible: 'Bible', events: 'Evenements',
    tithesOfferings: 'Dimes et Offrandes', onlineGiving: 'Don en Ligne',
    donorAnalytics: 'Analyse des Donateurs', pledges: 'Promesses',
    engagementScores: "Scores d'Engagement", followUps: 'Suivis',
    appointments: 'Rendez-vous', consultations: 'Consultations',
    prayerRequests: 'Demandes de Priere', testimonies: 'Temoignages', announcements: 'Annonces',
    userManagement: 'Gestion des Utilisateurs', assets: 'Actifs/Inventaire',
    campaigns: 'Campagnes', documents: 'Documents', reports: 'Rapports',
    reportBuilder: 'Generateur de Rapports', automation: 'Automatisation',
    settings: 'Parametres', aiAssistant: 'Assistant IA', aiAnalytics: 'Analyse IA',
    sermonTools: 'Outils de Sermon',
    // Sections
    main: 'Principal', aiTools: 'Outils IA', people: 'Personnes', worship: 'Culte',
    giving: 'Offrandes', care: 'Soins', admin: 'Admin',
    // Common
    welcome: 'Bienvenue', signIn: 'Se Connecter', signOut: 'Deconnexion',
    createAccount: 'Creer un Compte', save: 'Enregistrer', cancel: 'Annuler',
    delete: 'Supprimer', edit: 'Modifier', add: 'Ajouter', search: 'Rechercher',
    loading: 'Chargement...', noData: 'Aucune donnee', profile: 'Profil',
    submit: 'Soumettre', close: 'Fermer', viewAll: 'Voir Tout', email: 'Email',
    password: 'Mot de passe', phone: 'Telephone', name: 'Nom', firstName: 'Prenom',
    lastName: 'Nom', status: 'Statut', active: 'Actif', inactive: 'Inactif',
    pending: 'En attente', completed: 'Termine', date: 'Date', time: 'Heure',
    type: 'Type', amount: 'Montant', total: 'Total',
    actions: 'Actions', details: 'Details', description: 'Description', notes: 'Notes',
    // Dashboard
    totalMembers: 'Total des Membres', todayAttendance: "Presence d'Aujourd'hui",
    thisMonthGiving: 'Offrandes du Mois', activeGroups: 'Groupes Actifs',
    dailyVerse: 'Verset du Jour', quickLinks: 'Acces Rapides',
    upcomingEvents: 'Evenements a Venir', recentAnnouncements: 'Annonces Recentes',
    whatsHappening: "Voici ce qui se passe dans votre eglise aujourd'hui",
    newMember: 'Nouveau Membre', recordAttendance: 'Enregistrer la Presence',
    announcement: 'Annonce', readBible: 'Lire la Bible', give: 'Donner', prayer: 'Priere',
    // Members
    addMember: 'Ajouter un Membre', searchMembers: 'Rechercher des membres...',
    memberAdded: 'Membre ajoute', memberUpdated: 'Membre mis a jour',
    memberDeleted: 'Membre supprime',
    // Attendance
    recordAttendanceTitle: 'Enregistrer la Presence', presentToday: "Presents Aujourd'hui",
    totalMembersLabel: 'Total des Membres', todayRecords: "Enregistrements d'Aujourd'hui",
    noAttendanceToday: "Aucune presence enregistree aujourd'hui",
    saveAttendance: 'Enregistrer la Presence',
    serviceType: 'Type de Service', present: 'Present', absent: 'Absent',
    // Giving
    recordGiving: 'Enregistrer un Don', totalGiving: 'Total des Dons',
    recentRecords: 'Enregistrements Recents', noGivingRecords: 'Aucun don enregistre pour le moment',
    givingRecorded: 'Don enregistre',
    tithe: 'Dime', offering: 'Offrande', donation: 'Don', pledge: 'Promesse',
    cash: 'Especes', card: 'Carte', bankTransfer: 'Virement Bancaire', online: 'En Ligne',
    paymentMethod: 'Mode de Paiement', donationType: 'Type de Don',
    // Events
    noEvents: 'Aucun evenement prevu', rsvp: 'Confirmer', registeredForEvent: "Inscrit a l'evenement",
    // Bible
    dailyVerseTitle: 'Verset du Jour', searchBible: 'Rechercher dans la Bible',
    bookmarks: 'Favoris', noBookmarks: 'Aucun favori pour le moment',
    bookmarkSaved: 'Favori enregistre',
    // Prayer
    newPrayerRequest: 'Nouvelle Demande de Priere', submitAnonymously: 'Soumettre Anonymement',
    submitRequest: 'Soumettre la Demande', noPrayerRequests: 'Aucune demande de priere',
    // Announcements
    noAnnouncements: 'Aucune annonce', pinned: 'Epingle',
    // Profile
    changePassword: 'Changer le Mot de passe', currentPassword: 'Mot de passe Actuel',
    newPassword: 'Nouveau Mot de passe', profileUpdated: 'Profil mis a jour',
    passwordChanged: 'Mot de passe modifie',
    // Settings
    churchProfile: "Profil de l'Eglise", apiKeys: 'Cles API',
    saveChurchProfile: "Enregistrer le Profil de l'Eglise", saveApiKeys: 'Enregistrer Toutes les Cles API',
    // Check-In
    qrCode: 'Code QR', checkIn: "S'enregistrer", checkInLog: 'Journal des Enregistrements',
    totalCheckIns: 'Total des Enregistrements', today: "Aujourd'hui", generateQR: 'Generer le Code QR',
    checkedIn: 'Enregistrement reussi', alreadyCheckedIn: 'Deja enregistre',
    downloadQR: 'Telecharger le Code QR', selectEvent: 'Selectionner un evenement...',
    // Engagement
    engagementTitle: 'Engagement des Membres', avgScore: 'Score Moyen',
    engaged: 'Engage', atRisk: 'A Risque', disengaged: 'Desengage',
    // Donor Analytics
    avgGift: 'Don Moyen', totalGifts: 'Total des Dons', activeDonors: 'Donateurs Actifs',
    newDonors: 'Nouveaux Donateurs (30j)', lapsedDonors: 'Donateurs Inactifs',
    monthlyTrends: 'Tendances Mensuelles', breakdown: 'Repartition', topDonors: 'Principaux Donateurs',
    // AI Analytics
    aiChurchAnalytics: "Analyse IA de l'Eglise", generateAISummary: 'Generer le Resume IA',
    generating: 'Generation...', weekDetails: 'Details de la Semaine',
    pastSummaries: 'Resumes Precedents', aiSummary: 'Resume IA',
    noSummaryYet: 'Aucun resume IA pour le moment', generateNow: 'Generer Maintenant',
    // Automation
    automationWorkflows: "Flux d'Automatisation", executeAll: 'Executer Toutes les Automatisations',
    executeNow: 'Executer Maintenant', running: 'En cours...',
    executionHistory: "Historique d'Execution", automationSchedule: "Calendrier d'Automatisation",
    // Online Giving
    makeADonation: 'Faire un Don', selectAmount: 'Selectionner le Montant',
    customAmount: 'Montant personnalise', recurringDonation: 'En faire un don recurrent',
    donorInfo: 'Informations du Donateur', fullName: 'Nom Complet', emailAddress: 'Adresse Email',
    donate: 'Donner', whyGive: 'Pourquoi Donner?',
    // Reports
    generateReport: 'Generer le Rapport', exportCSV: 'Exporter en CSV',
    noReportGenerated: 'Aucun rapport genere', configureReport: 'Configurer le Rapport',
    reportType: 'Type de Rapport', dateRange: 'Plage de Dates', fromDate: 'Date de Debut', toDate: 'Date de Fin',
    // Language
    language: 'Langue',
  },
  pt: {
    // Nav
    dashboard: 'Painel', notifications: 'Notificacoes', messages: 'Mensagens',
    members: 'Membros', visitors: 'Visitantes', families: 'Familias', volunteers: 'Voluntarios',
    groups: 'Grupos e Ministerios', ministries: 'Ministerios/Dptos', attendance: 'Frequencia',
    eventCheckIn: 'Check-In', servicePlanner: 'Planejador', liveStream: 'Ao Vivo',
    mediaSermons: 'Midia e Sermoes', bible: 'Biblia', events: 'Eventos',
    tithesOfferings: 'Dizimos e Ofertas', onlineGiving: 'Oferta Online',
    donorAnalytics: 'Analise de Doadores', pledges: 'Promessas',
    engagementScores: 'Pontuacao de Engajamento', followUps: 'Acompanhamentos',
    appointments: 'Agendamentos', consultations: 'Consultas',
    prayerRequests: 'Pedidos de Oracao', testimonies: 'Testemunhos', announcements: 'Anuncios',
    userManagement: 'Gestao de Usuarios', assets: 'Ativos/Inventario',
    campaigns: 'Campanhas', documents: 'Documentos', reports: 'Relatorios',
    reportBuilder: 'Construtor de Relatorios', automation: 'Automacao',
    settings: 'Configuracoes', aiAssistant: 'Assistente IA', aiAnalytics: 'Analise IA',
    sermonTools: 'Ferramentas de Sermao',
    // Sections
    main: 'Principal', aiTools: 'Ferramentas IA', people: 'Pessoas', worship: 'Adoracao',
    giving: 'Ofertas', care: 'Cuidado', admin: 'Admin',
    // Common
    welcome: 'Bem-vindo', signIn: 'Entrar', signOut: 'Sair', createAccount: 'Criar Conta',
    save: 'Salvar', cancel: 'Cancelar', delete: 'Excluir', edit: 'Editar', add: 'Adicionar',
    search: 'Buscar', loading: 'Carregando...', noData: 'Sem dados', profile: 'Perfil',
    submit: 'Enviar', close: 'Fechar', viewAll: 'Ver Tudo', email: 'Email',
    password: 'Senha', phone: 'Telefone', name: 'Nome', firstName: 'Nome', lastName: 'Sobrenome',
    status: 'Status', active: 'Ativo', inactive: 'Inativo', pending: 'Pendente',
    completed: 'Concluido', date: 'Data', time: 'Hora', type: 'Tipo', amount: 'Valor', total: 'Total',
    actions: 'Acoes', details: 'Detalhes', description: 'Descricao', notes: 'Notas',
    // Dashboard
    totalMembers: 'Total de Membros', todayAttendance: 'Frequencia de Hoje',
    thisMonthGiving: 'Ofertas do Mes', activeGroups: 'Grupos Ativos',
    dailyVerse: 'Versiculo do Dia', quickLinks: 'Acesso Rapido',
    upcomingEvents: 'Proximos Eventos', recentAnnouncements: 'Anuncios Recentes',
    whatsHappening: 'Veja o que esta acontecendo na sua igreja hoje',
    newMember: 'Novo Membro', recordAttendance: 'Registrar Frequencia', announcement: 'Anuncio',
    readBible: 'Ler a Biblia', give: 'Ofertar', prayer: 'Oracao',
    // Members
    addMember: 'Adicionar Membro', searchMembers: 'Buscar membros...',
    memberAdded: 'Membro adicionado', memberUpdated: 'Membro atualizado',
    memberDeleted: 'Membro excluido',
    // Attendance
    recordAttendanceTitle: 'Registrar Frequencia', presentToday: 'Presentes Hoje',
    totalMembersLabel: 'Total de Membros', todayRecords: 'Registros de Hoje',
    noAttendanceToday: 'Nenhuma frequencia registrada hoje', saveAttendance: 'Salvar Frequencia',
    serviceType: 'Tipo de Culto', present: 'Presente', absent: 'Ausente',
    // Giving
    recordGiving: 'Registrar Oferta', totalGiving: 'Total de Ofertas',
    recentRecords: 'Registros Recentes', noGivingRecords: 'Ainda nao ha registros de ofertas',
    givingRecorded: 'Oferta registrada',
    tithe: 'Dizimo', offering: 'Oferta', donation: 'Doacao', pledge: 'Promessa',
    cash: 'Dinheiro', card: 'Cartao', bankTransfer: 'Transferencia Bancaria', online: 'Online',
    paymentMethod: 'Metodo de Pagamento', donationType: 'Tipo de Doacao',
    // Events
    noEvents: 'Nenhum evento agendado', rsvp: 'Confirmar', registeredForEvent: 'Inscrito no evento',
    // Bible
    dailyVerseTitle: 'Versiculo do Dia', searchBible: 'Buscar na Biblia',
    bookmarks: 'Favoritos', noBookmarks: 'Ainda nao ha favoritos',
    bookmarkSaved: 'Favorito salvo',
    // Prayer
    newPrayerRequest: 'Novo Pedido de Oracao', submitAnonymously: 'Enviar Anonimamente',
    submitRequest: 'Enviar Pedido', noPrayerRequests: 'Nenhum pedido de oracao',
    // Announcements
    noAnnouncements: 'Nenhum anuncio', pinned: 'Fixado',
    // Profile
    changePassword: 'Alterar Senha', currentPassword: 'Senha Atual',
    newPassword: 'Nova Senha', profileUpdated: 'Perfil atualizado',
    passwordChanged: 'Senha alterada',
    // Settings
    churchProfile: 'Perfil da Igreja', apiKeys: 'Chaves API',
    saveChurchProfile: 'Salvar Perfil da Igreja', saveApiKeys: 'Salvar Todas as Chaves API',
    // Check-In
    qrCode: 'Codigo QR', checkIn: 'Registrar', checkInLog: 'Registro de Check-In',
    totalCheckIns: 'Total de Registros', today: 'Hoje', generateQR: 'Gerar Codigo QR',
    checkedIn: 'Registrado com sucesso', alreadyCheckedIn: 'Ja registrado',
    downloadQR: 'Baixar Codigo QR', selectEvent: 'Selecionar evento...',
    // Engagement
    engagementTitle: 'Engajamento dos Membros', avgScore: 'Pontuacao Media',
    engaged: 'Engajado', atRisk: 'Em Risco', disengaged: 'Desengajado',
    // Donor Analytics
    avgGift: 'Doacao Media', totalGifts: 'Total de Doacoes', activeDonors: 'Doadores Ativos',
    newDonors: 'Novos Doadores (30d)', lapsedDonors: 'Doadores Inativos',
    monthlyTrends: 'Tendencias Mensais', breakdown: 'Detalhamento', topDonors: 'Principais Doadores',
    // AI Analytics
    aiChurchAnalytics: 'Analise IA da Igreja', generateAISummary: 'Gerar Resumo IA',
    generating: 'Gerando...', weekDetails: 'Detalhes da Semana',
    pastSummaries: 'Resumos Anteriores', aiSummary: 'Resumo IA',
    noSummaryYet: 'Ainda nao ha resumo IA', generateNow: 'Gerar Agora',
    // Automation
    automationWorkflows: 'Fluxos de Automacao', executeAll: 'Executar Todas as Automacoes',
    executeNow: 'Executar Agora', running: 'Executando...',
    executionHistory: 'Historico de Execucao', automationSchedule: 'Agenda de Automacao',
    // Online Giving
    makeADonation: 'Fazer uma Oferta', selectAmount: 'Selecionar Valor',
    customAmount: 'Valor personalizado', recurringDonation: 'Tornar esta uma oferta recorrente',
    donorInfo: 'Informacoes do Doador', fullName: 'Nome Completo', emailAddress: 'Endereco de Email',
    donate: 'Ofertar', whyGive: 'Por que Ofertar?',
    // Reports
    generateReport: 'Gerar Relatorio', exportCSV: 'Exportar CSV',
    noReportGenerated: 'Nenhum relatorio gerado', configureReport: 'Configurar Relatorio',
    reportType: 'Tipo de Relatorio', dateRange: 'Intervalo de Datas', fromDate: 'Data Inicial', toDate: 'Data Final',
    // Language
    language: 'Idioma',
  },
};

export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Espanol' },
  { code: 'fr', name: 'Francais' },
  { code: 'pt', name: 'Portugues' },
];

export function getTranslation(lang, key) {
  return translations[lang]?.[key] || translations.en[key] || key;
}

export function useTranslation() {
  const lang = localStorage.getItem('language') || 'en';
  const t = (key) => getTranslation(lang, key);
  const setLanguage = (code) => {
    localStorage.setItem('language', code);
    window.location.reload();
  };
  return { t, lang, setLanguage };
}

export default translations;
